import { FiscalInvoiceStatus } from "../../../services/fiscalService";

export const operationLabel: Record<string, string> = {
  import_entry: "Entrada de importação",
  import_entry_on_behalf: "Entrada (conta e ordem)",
  on_behalf_shipment: "Remessa conta e ordem",
  on_behalf_shipment_child: "NF filhote",
  sale: "Venda",
  sale_on_order: "Venda encomenda",
  complementary: "Complementar",
  other: "Outra",
};

export const statusInfo: Record<FiscalInvoiceStatus, { label: string; color: string }> = {
  draft: { label: "Rascunho", color: "gray" },
  processing: { label: "Processando", color: "blue" },
  authorized: { label: "Autorizada", color: "green" },
  rejected: { label: "Recusada", color: "red" },
  denied: { label: "Denegada", color: "red" },
  cancelled: { label: "Cancelada", color: "orange" },
};

/**
 * Número digitado em pt-BR: "14.598,5" → 14598.5, "1.000" → 1000, "26.5" → 26.5.
 * Vazio = null; texto inválido = NaN (a tela bloqueia).
 */
export const parseDecimal = (v: string): number | null => {
  const t = v.trim();
  if (t === "") return null;
  // Só dígitos com separadores (Number() aceitaria "Infinity", "1e3", "0x10")
  if (/^(\d{1,3}(\.\d{3})+|\d+),\d+$/.test(t)) return Number(t.replace(/\./g, "").replace(",", "."));
  // "1.500" = mil e quinhentos; "0.500" = meio
  if (/^[1-9]\d{0,2}(\.\d{3})+$/.test(t)) return Number(t.replace(/\./g, ""));
  if (/^\d+(\.\d+)?$/.test(t)) return Number(t);
  return NaN;
};

/** Número para campo editável em pt-BR (vírgula decimal), para o parseDecimal ler de volta igual. */
export const decimalInput = (n?: number | null): string => (n == null ? "" : String(n).replace(".", ","));

/**
 * Peso em kg: "1.250" (ponto + 3 casas, sem vírgula) é ambíguo (1,25 ou 1250?) e vira inválido.
 * Quantidade segue o parseDecimal ("1.500" = 1500; o saldo da mãe pega o engano).
 */
export const parseWeight = (v: string): number | null => (/^\d{1,3}\.\d{3}$/.test(v.trim()) ? NaN : parseDecimal(v));
